import { Table } from '@phosphor-icons/react';

export default Table;
